import { ExpressionType } from '../ExpressionType';
import createBinaryExpression from './createBinaryExpression';
export default function createOrElse(left, right) {
    return createBinaryExpression(ExpressionType.OrElse, left, right);
}
